import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { catalogModule } from './modules/catalog';
import { keyVaultPlugin } from './plugins/key-vault';
import { ownerPickerPlugin } from './plugins/owner-picker';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          providers={[
            {
              id: 'microsoft-auth-provider',
              title: 'Microsoft',
              message: 'Sign in with your Entra account',
              apiRef: microsoftAuthApiRef,
            },
          ]}
        />
      ),
  },
});

const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    catalogModule,
    authModule,
    keyVaultPlugin,
    ownerPickerPlugin,
  ],
});
